
import { supabase } from "@/integrations/supabase/client";
import { createLogger } from "../utils/loggingUtils";
import { toast } from "sonner";
import { Profile } from "./types";

const logger = createLogger('publicProfile');

export const fetchPublicProfile = async (userId: string): Promise<Profile | null> => {
  try {
    const { data, error } = await supabase
      .from("profiles")
      .select(`
        id,
        username,
        display_username,
        lab,
        university,
        location,
        city,
        country,
        research_interests,
        expertise,
        linkedin_url,
        website_url,
        credit_balance,
        is_admin,
        email_notifications,
        notify_swap_offers,
        notify_swap_responses,
        daily_digest_email,
        created_at
      `)
      .eq("id", userId)
      .single();

    if (error) {
      logger.error("Error fetching public profile:", error);
      toast.error("Failed to load user profile");
      return null;
    }

    return data as Profile;
  } catch (error) {
    logger.error("Exception fetching public profile:", error);
    toast.error("An unexpected error occurred");
    return null;
  }
};

// Helper function to check if a profile exists without creating one
export const checkProfileExists = async (userId: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase
      .from("profiles")
      .select("id")
      .eq("id", userId)
      .maybeSingle();
      
    if (error) {
      logger.error("Error checking profile existence:", error);
      return false;
    }
    
    return !!data;
  } catch (error) {
    logger.error("Exception checking profile existence:", error);
    return false;
  }
};
